module.exports = __webpack_public_path__ + "static/garena-logo-628916611b96fc7fc86bbfcf1a32cd2a.png";